/**
 * 业务 API (session cookie 鉴权)。S1 先落 auth; 项目/章节等 M1 续。
 * 端点对照 NF /v1 契约手写 (不复用 MuMu types)。
 */
import { request } from './http'

export interface User {
  user_id: string
  username: string
  is_admin?: boolean
}

export const sessionApi = {
  login: (username: string, password: string, captcha?: string, captchaSalt?: string) => {
    const body = {
      username,
      password,
      ...(captcha ? { captcha } : {}),
      ...(captchaSalt ? { captcha_salt: captchaSalt } : {}),
    }
    return request<User>('/v1/auth/login', { method: 'POST', body, skipAuthRedirect: true })
  },

  logout: () => request<void>('/v1/auth/logout', { method: 'POST' }),

  me: (signal?: AbortSignal) => request<User>('/v1/auth/me', { signal }),

  changePassword: (old_password: string, new_password: string) =>
    request<void>('/v1/auth/password', { method: 'POST', body: { old_password, new_password } }),
}
